module.exports = __webpack_public_path__ + "static/media/vue-js.84252c7f.svg";